export default __webpack_public_path__ + "static/media/ims-logo.29cd4cd0.svg";